import { useState, useRef } from "react";
import * as React from "react";
import { AssetAllocationChart } from "./AssetAllocationChart";
import { AssetAllocationTable } from "./AssetAllocationTable";
import TableFilterDropdown from "../../../../../../../../react-core/Html/Components/TableFilterDropdown";
import AutoHeight from "../../../../../../../Shared/Components/AutoHeight";
import { RadiosEditor } from "../../../../../../../../react-core/Html/RadiosEditor";
import { AssetClassTypeTiersArray, AssetClassTypeTiersMap } from "../../../Resource/Contents";
import { AssetClassType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { InvestmentAssetClassAllocationModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentAssetClassAllocationModel";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";

interface IAssetClassAllocationWidget {
    data: InvestmentAssetClassAllocationModel;
    tier: AssetClassType;
    isHeadAccount: boolean;
    onApplyClick: (v: AssetClassType) => void;
}

export const AssetClassAllocationWidget = (props: IAssetClassAllocationWidget) => {
    enum Views {
        Table,
        Chart,
    }
    const [view, setView] = useState<Views>(Views.Chart);
    const [tier, setTier] = useState(props.tier);
    const toggleRef = useRef(null);

    const onCancelClick = () => {
        setTier(props.tier);
        toggleRef.current.close();
    };

    const { addEvent } = new AdviserSiteTagManager();

    return (
        <>
            <div className="row narrow-gutter pb-8">
                <div className="col-fluid col-bottom">
                    <h2 className="h3 mb-0">Asset class allocation</h2>
                </div>
                <div className="col-auto">
                    <button
                        onClick={() => {
                            addEvent({
                                event: "insightstab_interaction",
                                eventParameters: {
                                    eventAction: "interactions",
                                    eventCategory: eventCategoryForGTM.insightsTab,
                                    eventLabel: `asset class allocation - chart`,
                                },
                            });
                            setView(Views.Chart);
                        }}
                        aria-pressed={view == Views.Chart}
                        className="pie-chart-view-button"
                        title="Pie chart view"
                    >
                        <span className="sr-only">Set pie chart view</span>
                        <span className="icon" aria-hidden={true}></span>
                    </button>
                </div>
                <div className="col-auto">
                    <button
                        onClick={() => {
                            addEvent({
                                event: "insightstab_interaction",
                                eventParameters: {
                                    eventAction: "interactions",
                                    eventCategory: eventCategoryForGTM.insightsTab,
                                    eventLabel: `asset class allocation - table`,
                                },
                            });
                            setView(Views.Table);
                        }}
                        aria-pressed={view == Views.Table}
                        className="table-view-button"
                        title="Data table view"
                    >
                        <span className="sr-only">Set table view</span>
                        <span className="icon" aria-hidden={true}></span>
                    </button>
                </div>
                <div className="col-auto">
                    <TableFilterDropdown ref={toggleRef} title="Filter asset class">
                        <div>
                            <RadiosEditor
                                cssWrapper="rg-inline mb-10"
                                options={AssetClassTypeTiersArray}
                                getText={(v) => {
                                    return AssetClassTypeTiersMap[v];
                                }}
                                selected={tier}
                                onChange={(v) => {
                                    setTier(v);
                                }}
                            />
                            <div className="row narrow-gutter">
                                <div className="col-fluid text-right">
                                    <button className="btn secondary block-xxs" onClick={onCancelClick}>
                                        Cancel
                                    </button>
                                </div>
                                <div
                                    className="col-auto"
                                    onClick={() => {
                                        props.onApplyClick(tier);
                                        addEvent({
                                            event: "insightstab_tablefilter",
                                            filter: {
                                                tier: AssetClassTypeTiersMap[tier].toLowerCase(),
                                            },
                                        });

                                        toggleRef.current.close();
                                    }}
                                >
                                    <button className="btn primary block-xxs ml-20">Apply</button>
                                </div>
                            </div>
                        </div>
                    </TableFilterDropdown>
                </div>
            </div>
            <div className={view == Views.Chart ? "panel" : "panel pt-0 pb-0"}>
                <AutoHeight>
                    {view == Views.Chart ? (
                        <AssetAllocationChart data={props.data} />
                    ) : (
                        <AssetAllocationTable data={props.data} isHeadAccount={props.isHeadAccount} />
                    )}
                </AutoHeight>
            </div>
        </>
    );
};
